export const formatWithCommas = (value: any) => {
  if (!value) return "";
  const cleaned = value.toString().replace(/,/g, "").replace(/[^\d.]/g, "");
  const parts = cleaned.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const stripCommas = (value: any) => {
  return value?.toString().replace(/,/g, "") || "";
};
